import React, { useEffect, useState } from "react";
import { Col } from "antd";
import InProcess from "../assets/icons/in-process.svg";
import CircleTick from "../assets/icons/circle-tick.svg";
import SuccessTick from "../assets/icons/succees-tick.svg";
import { useSelector } from "react-redux";
import { BASE_URL, CHECKAUTH_ENDPOINT } from "../utils/constant";
import { setUserInformation } from "../store/slices/signUpSlice";
export default function SignUpSidebar(sidebarData) {
  const userInfo = useSelector((state) => state.signUp.signUpDetails);
const [locationFill, setLocationFill] = useState(false)
const [departmentFill, setDepartmentFill] = useState(false)
const [designationFill, setDesignationFill] = useState(false)
const [shiftFill, setShiftFill] = useState(false)
const [staffFill, setStaffFill] = useState(false)
  useEffect (() => {
    const token = localStorage.getItem('authToken');

      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${CHECKAUTH_ENDPOINT}`, {
          method: "GET",
           headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token }`,
                    
                  },
          body: JSON.stringify(),
        });
        
        if (response.ok) {
          const data = await response.json();
          setLocationFill(data?.data?.onboardingProgress?.location)
          setDepartmentFill(data?.data?.onboardingProgress?.department)
          setDesignationFill(data?.data?.onboardingProgress?.designation)
          setShiftFill(data?.data?.onboardingProgress?.shift)
          setStaffFill(data?.data?.onboardingProgress?.staff)

        } else {
          const data = await response.json();
          console.log('indexerr',data)
          
        };
      
      }
       fetchData();
	}, []);

  return (
    <Col lg={10}>
      <div className="h-full flex justify-center bg-loginBg bg-no-repeat bg-cover">
        <div className="pt-20">
          <div className="text-white text-center">
            <p className="text-3xl font-sbold">{userInfo?.companyName}</p>
            <p className="text-2xl text-white opacity-80 font-sbold mt-1">
              {userInfo?.firstName} {userInfo?.lastName}
            </p>
          </div>
          <div className="text-center table mx-auto text-lg text-[rgba(255,255,255,.5)] border rounded-[21px] px-9 py-3 border-[#2D5E8E6E] bg-[#11477D] mt-6 leading-8">
            Aadhar No.:<span className="ml-1">{userInfo?.aadharNumber}</span>
            <br />
            Phone No.:<span className="ml-1">{userInfo?.phoneNumber}</span>
            <br />
            Email:<span className="ml-1">{userInfo?.email}</span>
          </div>
          <div className="text-1xl text-white table mx-auto mt-16">
            <div className="flex items-center my-4 py-1">
              <img src={sidebarData.isLocation == true ? InProcess : locationFill == true ? SuccessTick : CircleTick} className="mr-2 -mt-0.5" /> Company Locations
            </div>
            <div className="flex items-center my-4 py-1">
              <img src={sidebarData.isDepartment == true || sidebarData.isDesignation == true ? InProcess : departmentFill == true && designationFill == true ? SuccessTick : CircleTick} className="mr-2 -mt-0.5" /> Departments &
              Designation
            </div>
            <div className="flex items-center my-4 py-1">
              <img src={sidebarData.isShift == true ?  InProcess : shiftFill == true ? SuccessTick : CircleTick} className="mr-2 -mt-0.5" /> Shifts
            </div>
            <div className="flex items-center my-4 py-1">
              <img src={sidebarData.isStaff == true ?  InProcess : staffFill == true ? SuccessTick : CircleTick} className="mr-2 -mt-0.5" /> Add Staff
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
}
